class NewOnDigiteketLoadMore {
  constructor({
    btnId,
    resultsId,
    action,
    loadingText = "Laddar...",
    doneText = "Ladda fler",
    forceReverse = false,
  }) {
    this.btn = document.getElementById(btnId);
    this.resultsWrapper = document.getElementById(resultsId);
    this.action = action;
    this.loadingText = loadingText;
    this.doneText = doneText;
    this.forceReverse = forceReverse;

    const perPage = 9;
    const renderedCards = this.resultsWrapper
      ? this.resultsWrapper.querySelectorAll(".card").length
      : 0;
    this.currentPage =
      renderedCards > 0
        ? Math.max(1, Math.ceil(renderedCards / perPage))
        : digiteketData.currentPage || 1;
    this.maxPage = digiteketData.maxPage || 1;
    this.nonce = digiteketData.nonce;
    this.ajaxUrl = digiteketData.ajaxUrl;
    this.init();
  }

  init() {
    if (!this.btn || !this.resultsWrapper) return;
    this.btn.addEventListener("click", () => this.handleClick());
  }

  handleClick() {
    this.setLoading(true);
    this.fetchNextPage()
      .then(({ items, maxNumPages }) => {
        this.appendItems(items);
        this.maxPage = maxNumPages;
        if (
          this._nextPageFromResponse &&
          Number.isInteger(this._nextPageFromResponse)
        ) {
          this.currentPage = this._nextPageFromResponse;
          this._nextPageFromResponse = null;
        } else {
          this.currentPage++;
        }
        this.updateButtonState();
      })
      .catch((err) => {
        console.error("AJAX error:", err);
        this.setLoading(false);
      });
  }

  fetchNextPage() {
    const params = this.encodeData({
      action: this.action,
      nonce: this.nonce,
      paged: this.currentPage + 1,
    });
    const url = `${this.ajaxUrl}?${params}`;

    return fetch(url, {
      method: "GET",
      headers: { "X-Requested-With": "XMLHttpRequest" },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        // response received
        if (!res.success || !res.data) throw new Error("Invalid response");
        // Capture server-provided current page if present to avoid desync
        const serverPage = res.data.currentPage || res.data.paged || null;
        if (serverPage != null) this._nextPageFromResponse = Number(serverPage);

        return {
          items: res.data.items || [],
          maxNumPages: res.data.maxNumPages || this.maxPage,
        };
      });
  }

  appendItems(items) {
    if (items && items.length) {
      let toAppend = items;
      if (this.forceReverse) toAppend = [...items].reverse();
      toAppend.forEach((item) => {
        this.resultsWrapper.insertAdjacentHTML("beforeend", item);
      });
    }
  }

  setLoading(isLoading) {
    if (!this.btn) return;
    if (isLoading) {
      this.btn.classList.add("animate--pulsate");
      this.btn.innerText = this.loadingText;
      this.btn.setAttribute("disabled", "");
    } else {
      this.btn.classList.remove("animate--pulsate");
      this.btn.innerText = this.doneText;
      this.btn.removeAttribute("disabled");
    }
  }

  updateButtonState() {
    this.setLoading(false);
    if (this.currentPage >= this.maxPage) {
      this.btn.setAttribute("disabled", "");
      this.btn.remove();
    }
  }

  encodeData(data) {
    return Object.entries(data)
      .map(
        ([key, value]) =>
          encodeURIComponent(key) + "=" + encodeURIComponent(value),
      )
      .join("&");
  }
}

export default NewOnDigiteketLoadMore;
